export default class {
    constructor (TokenService) {
        this.TokenService = TokenService;
    }

    getPreferredI18n (i18ns) {
        const activeLanguage = this.TokenService.getActiveLanguage();
        const defaultLanguage = this.TokenService.getCompanyLanguage();
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();

        // Priority 1: Active language (if enabled)
        if (i18ns[activeLanguage] && this.isEnabled(i18ns[activeLanguage])) {
            return i18ns[activeLanguage];
        }

        // Priority 2: Default language (if enabled)
        if (i18ns[defaultLanguage] && this.isEnabled(i18ns[defaultLanguage])) {
            return i18ns[defaultLanguage];
        }

        // Priority 3: Any supported language (if enabled)
        const supportedLang = companySupportedLanguages.find(lang => i18ns[lang] && this.isEnabled(i18ns[lang]));
        if (supportedLang) {
            return i18ns[supportedLang];
        }

        // Fallback: First available enabled language in i18ns
        const firstAvailableKey = Object.keys(i18ns).find(key => i18ns[key] && this.isEnabled(i18ns[key]));
        return firstAvailableKey ? i18ns[firstAvailableKey] : null;
    }

    isEnabled (i18n) {
        if (!i18n) return false;
        // Check isEnabled field (backend uses this format)
        if (i18n.hasOwnProperty('isEnabled')) {
            return !!i18n.isEnabled;
        }
        // Check is_enabled field (alternative format)
        if (i18n.hasOwnProperty('is_enabled')) {
            return !!i18n.is_enabled;
        }
        // If no enabled field exists, consider it enabled (backward compatibility)
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/i18n/index.js